export default __webpack_public_path__ + "static/media/france-square.f33da34d.png";